import { formatDate } from '@angular/common';
import { IBlockTimeItem } from 'src/app/ReusableComponent/block-time-report/block-time-report.model';
import { BlockTimeFactInterface } from '../interfaces/block-time-fact.interface';
import { BLOCK_TIME_EMPTY_VALUE } from '../properties/block-time-record-modal.properties';

/**
 * Maps a block time record to the read-only service request facts, in display order.
 */
export function mapBlockTimeFacts(record: Partial<IBlockTimeItem> | null): BlockTimeFactInterface[] {
  return [
    { label: 'Trip #', value: toText(record?.tripID) },
    { label: 'Customer', value: toText(record?.customer?.customerName), isWide: true },
    { label: 'Date', value: record?.srCreatedOnDate ? formatDate(record.srCreatedOnDate, 'MM/dd/yyyy', 'en-US') : BLOCK_TIME_EMPTY_VALUE },
    { label: 'SR type', value: toText(record?.serviceType) },
    { label: 'Organ type', value: toText(record?.additionalOrgans) },
    { label: 'UNOS ID', value: toText(record?.unosid) },
    { label: 'Ground vendor', value: toText(record?.groundVendor) },
    { label: 'Air vendor', value: toText(record?.airVendor) },
    { label: 'Tail number', value: toText(record?.tailNumber) },
    { label: 'Aircraft type', value: toText(record?.aircraftType) },
    { label: 'Aircraft size', value: toText(record?.aircraftSize) },
  ];
}

function toText(value: string | null | undefined): string {
  return value?.toString().trim() || BLOCK_TIME_EMPTY_VALUE;
}
